import { Container, Empty } from "@eventsquare/uikit";
import styles from "./NoPosPermission.module.scss";
import { useTranslation } from "react-i18next";

export const NoPosPermission = () => {
  const { t } = useTranslation("components_no_pos_permission");

  return (
    <div className={styles.warningWrapper}>
      <Container>
        <Empty
          type="warning"
          title={t("no_permission_title")}
          lead={t("no_permission_lead")}
        />
      </Container>
    </div>
  );
};
